/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M15.211 1C12.895 1 11 2.92 11 5.267v39.466C11 47.08 12.895 49 15.211 49H34.79C37.105 49 39 47.08 39 44.733V5.267C39 2.92 37.105 1 34.789 1H15.21zm7.444 4.11h4.694c.309 0 .559.358.559.8 0 .443-.25.801-.559.801h-4.694c-.31 0-.559-.358-.559-.8 0-.443.25-.801.559-.801zm-9.34 5.703h23.374v28.372H13.315V10.813zM25 41.45c1.44 0 2.607 1.183 2.607 2.641 0 1.459-1.168 2.642-2.607 2.642-1.44 0-2.607-1.183-2.607-2.642 0-1.458 1.167-2.641 2.607-2.641z" _fill="#404A57" fill-rule="evenodd"/>'
  }
})
